// src/components/mf-nav-lock.ts
class MfNavLock {
  private static collapseSelector = '#navbarContent';
  private static lockClass = 'nav-open';
  private static nodes: Element[] = [];
  private static boundShow: ((ev: Event) => void) | null = null;
  private static boundHidden: ((ev: Event) => void) | null = null;
  private static locked = false;
  private static savedScrollY = 0;

  /**
   * Aktiviert den Scroll-Lock für (ein oder mehrere) Collapse-Elemente.
   * @param opts.collapseSelector CSS-Selector für das/ die Collapse-Element(e) (Default: '#navbarContent')
   * @param opts.lockClass        Klasse, die auf <html> & <body> gesetzt wird (Default: 'nav-open')
   */
  static init(opts?: { collapseSelector?: string; lockClass?: string }): void {
    this.collapseSelector = opts?.collapseSelector ?? '#navbarContent';
    this.lockClass = opts?.lockClass ?? 'nav-open';

    this.boundShow = () => this.lock();
    this.boundHidden = () => this.unlock();

    this.nodes = Array.from(document.querySelectorAll(this.collapseSelector));
    if (this.nodes.length === 0) return;

    // Events anhängen
    for (const el of this.nodes) {
      el.addEventListener('show.bs.collapse', this.boundShow!, { passive: true });
      el.addEventListener('hidden.bs.collapse', this.boundHidden!, { passive: true });
    }

    // Falls beim Laden bereits offen
    const isOpen = this.nodes.some((n) => n.classList.contains('show'));
    if (isOpen) this.lock();
  }

  /** Manuell locken (z. B. für eigene Overlays) */
  static lock(): void {
    if (this.locked) return;
    this.locked = true;

    this.savedScrollY = window.scrollY || window.pageYOffset || 0;

    // Klassen setzen (für CSS overflow:hidden etc.)
    document.documentElement.classList.add(this.lockClass);
    document.body.classList.add(this.lockClass);

    // iOS-sicherer Lock ohne Layout-Shift
    const b = document.body as HTMLElement;
    b.style.position = 'fixed';
    b.style.top = `-${this.savedScrollY}px`;
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
  }

  /** Lock aufheben und ursprüngliche Scrollposition wiederherstellen */
  static unlock(): void {
    if (!this.locked) return;
    this.locked = false;

    document.documentElement.classList.remove(this.lockClass);
    document.body.classList.remove(this.lockClass);

    const b = document.body as HTMLElement;
    const top = parseInt(b.style.top || '0', 10);

    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';

    // zurück zur alten Position
    window.scrollTo(0, -top || 0);
  }

  /** Events entfernen (z. B. bei Hot-Reload/SPA-Unmount) */
    static destroy(): void {
        for (const el of this.nodes) {
            if (this.boundShow)   el.removeEventListener('show.bs.collapse', this.boundShow);
            if (this.boundHidden) el.removeEventListener('hidden.bs.collapse', this.boundHidden);
        }
        this.nodes = [];
        this.boundShow = null;     // << hier
        this.boundHidden = null;   // << und hier
        if (this.locked) this.unlock();
    }
}

export default MfNavLock;
